import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import BellmanList from "./BellmanList";
import Reports from "../reports/index";
import PoolTipsList from "../PollTips/PoolTipsList";
import VerifiedPoolTipsList from "../PollTips/VerifiedPoolTipsList";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboard,
  faUsers,
  faCircleCheck,
  faPeopleGroup,
} from "@fortawesome/free-solid-svg-icons";

const BellMan = ({
  toAddMaid,
  toDeleteMaid,
  toDownload,
  isAdmin,
  canRead,
  poolTipEnabled,
}) => {
  const [activeScreen, setActiveScreen] = useState("bellman");

  const navButtons = [
    {
      key: "bellman",
      label: "Bell Staff",
      icon: faUsers,
    },

    ...(poolTipEnabled
      ? [
          {
            key: "team",
            label: "Pool Tips",
            icon: faPeopleGroup,
          },
          {
            key: "verifiedTips",
            label: "Verified Pool Tips",
            icon: faCircleCheck,
          },
        ]
      : []),

    {
      key: "reports",
      label: "Reports",
      icon: faClipboard,
    },
  ];

  return (
    <>
      <Row className="my-4 justify-content-center gx-3">
        {navButtons.map(({ key, label, icon }) => (
          <Col
            key={key}
            xs={6}
            md={3}
            className="d-flex justify-content-center mb-2 mb-md-0"
          >
            <Button
              className="w-100 py-2 rounded-4"
              variant={activeScreen === key ? "primary" : "outline-secondary"}
              onClick={() => setActiveScreen(key)}
            >
              <FontAwesomeIcon icon={icon} className="me-2" />
              {label}
            </Button>
          </Col>
        ))}
      </Row>

      <Row>
        <Col>
          {activeScreen === "bellman" && (
            <BellmanList toAddMaid={toAddMaid} toDeleteMaid={toDeleteMaid} />
          )}

          {activeScreen === "team" && poolTipEnabled && (
            <PoolTipsList canRead={canRead} service="bellman" />
          )}

          {activeScreen === "verifiedTips" && poolTipEnabled && (
            <VerifiedPoolTipsList canRead={canRead} service="bellman" />
          )}

          {activeScreen === "reports" && (
            <Reports toDownload={toDownload} isAdmin={isAdmin} type="bellman" />
          )}
        </Col>
      </Row>
    </>
  );
};

export default BellMan;
